'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _ServerSelector = require('./ServerSelector');

var _ServerSelector2 = _interopRequireDefault(_ServerSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    components: {
        ServerSelector: _ServerSelector2.default
    },
    props: ['network'],
    data: function data() {
        return {
            server_type: 'network',
            znc_username: '',
            znc_network: '',
            znc_password: '',
            show_advanced: false,
            switch_tabs_on_connect: false,
            network_list: []
        };
    },

    computed: {
        settingShowRaw: {
            get: function get() {
                return this.network.setting('show_raw');
            },
            set: function set(val) {
                return this.network.setting('show_raw', val);
            }
        }
    },
    watch: {
        znc_username: function znc_username() {
            this.setZncPass();
        },
        znc_network: function znc_network() {
            this.setZncPass();
        },
        znc_password: function znc_password() {
            this.setZncPass();
        },
        'network.state': function networkState() {
            if (!this.switch_tabs_on_connect) {
                return;
            }

            if (this.network.state === 'connected') {
                this.switch_tabs_on_connect = false;
                this.$state.$emit('server.tab.show', 'messages');
            } else if (this.network.state_error) {
                this.switch_tabs_on_connect = false;
            }
        }
    },
    created: function created() {
        var isZnc = !!(this.network.password || '').match(/^(.*)\/(.*):(.*)$/);
        this.server_type = isZnc ? 'znc' : 'network';
        if (isZnc) {
            var match = (this.network.password || '').match(/^(.*)\/(.*):(.*)$/);
            this.znc_username = match[1] || '';
            this.znc_network = match[2] || '';
            this.znc_password = match[3] || '';
        }

        this.network_list = this.$state.setting('presetNetworks') || [];
    },

    methods: {
        readableStateError: function readableStateError(err) {
            return Misc.networkErrorMessage(err);
        },
        connect: function connect() {
            this.switch_tabs_on_connect = true;
            this.network.ircClient.connect();
        },
        reconnect: function reconnect() {
            this.network.ircClient.connect();
        },
        removeNetwork: function removeNetwork() {
            var confirmed = confirm('Really remove this network? This cannot be undone!');
            if (!confirmed) {
                return;
            }

            this.$state.removeNetwork(this.network.id);
            this.$state.$emit('active.component');
        },
        setZncPass: function setZncPass() {
            var newPass = this.znc_username + '/' + this.znc_network + ':' + this.znc_password;
            this.network.password = newPass;
        },
        toggleTls: function toggleTls() {
            var connection = this.network.connection;
            connection.tls = !connection.tls;

            if (connection.tls && connection.port === 6667) {
                connection.port = 6697;
            } else if (!connection.tls && connection.port === 6697) {
                connection.port = 6667;
            }
        },
        onServerInput: function onServerInput(server) {
            this.network.connection.server = server.server;
            this.network.connection.port = server.port;
            this.network.connection.tls = server.tls;
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NetworkSettings"]
window._kiwi_exports.components.NetworkSettings = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NetworkSettings.vue
// module id = hqyo
// module chunks = 1